export default __webpack_public_path__ + "static/media/cola.7f2e4934.png";